const ASSET_ID = 21364625;
const ADDRESS_1 = "DQ2NPLGQ3CV3QAPMS7KHIRUNUF2ZSTYRT5SZGDCPLB7VPC5OSSLCI5H7DM";
const ADDRESS_2 = "6P6D5KQH5VIXEJGW6LXPUMEZ77XNLHQXB6GMW4CBDBN2VJ4CFZ7HCIKUBM";
const URL = "https://choice-coin-api.herokuapp.com";
const ELECTION_ID = "0eac92ff-f575-4f8b-914f-2cd03ab5705a";
export { ASSET_ID, URL, ELECTION_ID, ADDRESS_1, ADDRESS_2 };
